import { createI18n, type VueMessageType } from 'vue-i18n';
import type { MessageFunctionReturn } from '@intlify/core-base';

const locale = import.meta.env.VITE_I18N_LOCALE || 'en';
const fallbackLocale: string = import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en';
// Create VueI18n instance, set legacy to false always
const i18n = createI18n<false>({
  locale,
  fallbackLocale,
  legacy: false,
  postTranslation: (translation, key): MessageFunctionReturn<VueMessageType> => {
    if (translation === '') {
      if (import.meta.env.VITE_WEBMAIL_ENVIRONMENT !== 'production') {
        return key;
      }
      const parts = key.split('.');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let message = (i18n.global.messages.value as Record<string, any>)[fallbackLocale];
      for (const key of parts) {
        if (key in message) {
          message = message[key];
        } else {
          return translation;
        }
      }
      return message;
    }
    return translation;
  }
});
export default i18n;
